import React from 'react';
import { useTranslation } from 'react-i18next';

const Contact: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      {/* Heading */}
      <div className="text-center mb-12">
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            color: 'var(--color-text-primary)',
          }}
        >
          {t('contact.title', 'Contact Us')}
        </h1>
        <div
          className="mx-auto mt-4"
          style={{ width: 60, height: 3, background: 'var(--gradient-primary)', borderRadius: 2 }}
        />
        <p
          className="mt-6 max-w-sm mx-auto"
          style={{ fontFamily: 'var(--font-body)', fontSize: '1rem', lineHeight: 1.7, color: 'var(--color-text-secondary)' }}
        >
          {t('contact.chat.cta', 'Utilisez le chat en bas à droite pour nous écrire directement.')}
        </p>
      </div>

      {/* Contact info */}
      <div className="grid md:grid-cols-3 gap-4 text-center">
        {[
          {
            href: 'tel:+33670177126',
            label: '+33 6 70 17 71 26',
            icon: (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.09 9.82 19.79 19.79 0 01.07 1.18 2 2 0 012.03 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z" />
              </svg>
            ),
          },
          {
            href: 'mailto:contact@blueowl.fr',
            label: 'contact@blueowl.fr',
            icon: (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            ),
          },
          {
            href: 'https://www.linkedin.com/company/colibri-technologies-ltee',
            label: 'Blue Owl SAS',
            isLinkedIn: true,
            icon: (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" style={{ color: 'var(--color-primary)' }}>
                <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" />
              </svg>
            ),
          },
        ].map(({ href, icon, label, isLinkedIn }) => (
          <a
            key={href}
            href={href}
            target={isLinkedIn ? '_blank' : undefined}
            rel={isLinkedIn ? 'noopener noreferrer' : undefined}
            className="card-glass p-6 block transition-all group"
            style={{ borderRadius: 'var(--radius-xl)', textDecoration: 'none' }}
          >
            <div
              className="flex items-center justify-center mx-auto mb-3 rounded-xl"
              style={{
                width: 52,
                height: 52,
                background: 'var(--color-primary-subtle)',
                color: 'var(--color-primary)',
                transition: 'background 250ms',
              }}
            >
              {icon}
            </div>
            <span style={{ fontFamily: 'var(--font-body)', fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>
              {label}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Contact;
